// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-350d52c8] .d-modal .actions button{white-space:nowrap}", "",{"version":3,"sources":["webpack://./resources/js/Pages/Settings/SepaRetry/Create.vue"],"names":[],"mappings":"AACA,2CACI,kBAAA","sourcesContent":["\n:deep(.d-modal .actions button) {\n    white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
